import React from "react";

const NoticeBoardskPage = (props) => {
	return <div>{props.children}</div>;
};

export default NoticeBoardskPage;
